<template>
  <div class="flex h-screen">
    <div class="w-1/2 border-r-2 border-white p-10">
      <a href="#" @click.prevent="nextStep('f')">
        <div class="flag">
          <img src="images/female.svg" />
        </div>
        <div class="text">
          <h1>{{ getText('gender_woman') }}</h1>
        </div>
      </a>
    </div>
    <div class="w-1/2 border-l-2 border-white p-10">
      <a href="#" @click.prevent="nextStep('m')">
        <div class="flag">
          <img src="images/male.svg" />
        </div>
        <div class="text">
          <h1>{{ getText('gender_man') }}</h1>
        </div>
      </a>
    </div>
  </div>
</template>

<style scoped>
.flag {
  margin-top: 215px;
  margin-left: auto;
  margin-right: auto;
  width: 435px;
  background-color: white;
  padding: 30px;
  border-radius: 9999px;
}

.flag img {
  width: 100%;
}

.text {
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  font-size: 28px;
}

.text h1 {
  font-size: 66px;
  text-transform: uppercase;
}
</style>

<script>
export default {
  name: "Gender",
  methods: {
    getText(key) {
      return this.$settings.interface[key][this.$route.params.lang];
    },
    nextStep(gender) {
      this.$variables.gender = gender;
      this.$router.push({
        name: "adjust",
        params: { lang: this.$route.params.lang }
      });
    }
  }
};
</script>

